// src/screens/home/home-page-quick-links-selectors.ts
var homePageQuickLinksSelectors = {
  newInvoiceButton: "home-page-quick-links-new-invoice-button"
};

// src/screens/home/home-page-selectors.ts
var homePageSelectors = {
  quickLinks: {
    ...homePageQuickLinksSelectors
  }
};

// src/screens/home/home-page-widgets-selectors.ts
var homePageWidgetsSelectors = {
  quickActionsButton: "home-page-widgets-quick-actions-button",
  topKpiAcv: "home-page-widgets-top-kpi-acv",
  topKpiActiveCustomers: "home-page-widgets-top-kpi-active-customers",
  topKpiActiveContracts: "home-page-widgets-top-kpi-active-contracts",
  topKpiRenewalContracts: "home-page-widgets-top-kpi-renewal-contracts",
  topKpiPendingContracts: "home-page-widgets-top-kpi-pending-contracts",
  mrrWaterfallWidget: "home-page-widgets-mrr-waterfall",
  mrrWaterfallMrr: "home-page-widgets-mrr-waterfall-mrr",
  mrrWaterfallNrrGrr: "home-page-widgets-mrr-waterfall-nrr-grr",
  mrrWaterfallBeginningMrr: "home-page-widgets-mrr-waterfall-beginning-mrr",
  mrrWaterfallNewMrr: "home-page-widgets-mrr-waterfall-new-mrr",
  mrrWaterfallReactivationMrr: "home-page-widgets-mrr-waterfall-reactivation-mrr",
  mrrWaterfallExpansionMrr: "home-page-widgets-mrr-waterfall-expansion-mrr",
  mrrWaterfallContractionMrr: "home-page-widgets-mrr-waterfall-contraction-mrr",
  mrrWaterfallChurnMrr: "home-page-widgets-mrr-waterfall-churn-mrr",
  mrrWaterfallEndingMrr: "home-page-widgets-mrr-waterfall-ending-mrr",
  customersWidget: "home-page-widgets-customers",
  customersWidgetTotalCount: "home-page-widgets-customers-total-count",
  customersWidgetNewActiveCount: "home-page-widgets-customers-new-active-count",
  customersWidgetCtaButton: "home-page-widgets-customers-cta-button",
  contractsWidget: "home-page-widgets-contracts",
  contractsWidgetActiveCount: "home-page-widgets-contracts-active-count",
  contractsWidgetRenewalsCount: "home-page-widgets-contracts-renewals-count",
  contractsWidgetInactiveCount: "home-page-widgets-contracts-inactive-count",
  contractsWidgetImportedCount: "home-page-widgets-contracts-imported-count",
  contractsWidgetCtaButton: "home-page-widgets-contracts-cta-button",
  revenueTrendsWidget: "home-page-widgets-revenue-trends",
  revenueTrendsWidgetYtd: "home-page-widgets-revenue-trends-ytd",
  revenueTrendsWidgetArr: "home-page-widgets-revenue-trends-arr",
  revenueTrendsWidgetMrr: "home-page-widgets-revenue-trends-mrr",
  revenueTrendsWidgetChart: "home-page-widgets-revenue-trends-chart",
  revenueTrendsWidgetViewReport: "home-page-widgets-revenue-trends-view-report",
  arHealthWidget: "home-page-widgets-ar-health",
  arHealthWidgetDso: "home-page-widgets-ar-health-dso",
  arHealthWidgetOverdueList: "home-page-widgets-ar-health-overdue-list",
  arHealthWidgetOverdue0to30: "home-page-widgets-ar-health-overdue-0-to-30",
  arHealthWidgetOverdue30to60: "home-page-widgets-ar-health-overdue-30-to-60",
  arHealthWidgetOverdue60Plus: "home-page-widgets-ar-health-overdue-60-plus",
  arHealthWidgetCtaButton: "home-page-widgets-ar-health-cta-button",
  invoicesWidget: "home-page-widgets-invoices",
  invoicesWidgetViewInvoices: "home-page-widgets-invoices-view-invoices",
  invoicesWidgetChart: "home-page-widgets-invoices-chart",
  invoicesWidgetTotalOutstanding: "home-page-widgets-invoices-total-outstanding",
  invoicesWidgetBreakdownTotal: "home-page-widgets-invoices-breakdown-total",
  invoicesWidgetBreakdownInReview: "home-page-widgets-invoices-breakdown-in-review",
  invoicesWidgetBreakdownInOverage: "home-page-widgets-invoices-breakdown-in-overage",
  monthlyBreakdownWidget: "home-page-widgets-monthly-breakdown",
  monthlyBreakdownWidgetTotalAmount: "home-page-widgets-monthly-breakdown-total-amount",
  monthlyBreakdownWidgetInReviewAmount: "home-page-widgets-monthly-breakdown-in-review-amount",
  monthlyBreakdownWidgetInOverageAmount: "home-page-widgets-monthly-breakdown-in-overage-amount",
  monthlyBreakdownWidgetCtaButton: "home-page-widgets-monthly-breakdown-cta-button"
};

// src/screens/login/login-page-selectors.ts
var loginPageSelectors = {
  emailField: "login-page-email-field",
  passwordField: "login-page-password-field",
  loginButton: "login-page-login-button",
  loginErrorAlertTitle: "login-page-login-error-alert-title"
};

// src/screens/shared/dialog-selectors.ts
var dialogSelectors = {
  submitButton: "dialog-submit-button",
  cancelButton: "dialog-cancel-button"
};

// src/screens/invoices/invoices-selectors/invoices-overview-selectors.ts
var invoicesOverviewActionButtonSelector = "invoices-overview-action-button";
var invoicesOverviewColumnSelectors = {
  payment: "invoices-overview-payment",
  status: "invoices-overview-status",
  workflow: "invoices-overview-workflow",
  totalAmount: "invoices-overview-amount",
  totalAmountHeader: "invoices-overview-amount-header",
  currency: "invoices-overview-currency",
  customer: "invoices-overview-customer",
  subsidiary: "invoices-overview-subsidiary",
  period: "invoices-overview-period",
  invoiceNumber: "invoices-overview-invoice-number",
  issueDate: "invoices-overview-issue-date",
  dueDate: "invoices-overview-due-date",
  contractName: "invoices-overview-contract-name",
  contractStatus: "invoices-overview-contract-status",
  purchaseOrder: "invoices-overview-purchase-order",
  memo: "invoices-overview-memo"
};
var invoicesOverviewHighlightsSelectors = {
  root: "invoices-overview-highlights",
  totalCount: "invoices-overview-highlights-total-count",
  totalAmount: "invoices-overview-highlights-total-amount",
  inReviewCount: "invoices-overview-highlights-in-review-count",
  inReviewAmount: "invoices-overview-highlights-in-review-amount",
  overdueCount: "invoices-overview-highlights-overdue-count",
  overdueAmount: "invoices-overview-highlights-overdue-amount",
  pendingCount: "invoices-overview-highlights-pending-count",
  pendingAmount: "invoices-overview-highlights-pending-amount"
};
var invoicesOverviewDotsMenuSelectors = {
  dotOptions: "invoices-overview-dots-menu",
  createInvoice: "invoices-overview-dots-menu-create-invoice",
  approve: "invoices-overview-dots-menu-approve",
  shareViaEmail: "invoices-overview-dots-menu-share-via-email",
  download: "invoices-overview-dots-menu-download",
  downloadPdf: "invoices-overview-dots-menu-download-pdf",
  exportStatement: "invoices-overview-dots-menu-export-statement",
  markPaid: "invoices-overview-dots-menu-mark-paid"
};

// src/screens/invoices/invoices-selectors/mark-paid-dialog-selectors.ts
var markPaidDialogSelectors = {
  transactionId: "mark-paid-dialog-transaction-id",
  amount: "mark-paid-dialog-amount"
};

// src/screens/invoices/invoices-selectors/share-invoice-dialog-selectors.ts
var shareInvoiceDialogSelectors = {
  shareButton: "share-invoice-dialog-button",
  tableCells: "share-invoice-dialog-table-cells",
  amountField: "share-invoice-dialog-amount-field"
};

// src/screens/invoices/invoices-overview-page-selectors.ts
var invoicesOverviewPageSelectors = {
  actionButton: invoicesOverviewActionButtonSelector,
  columns: invoicesOverviewColumnSelectors,
  highlights: invoicesOverviewHighlightsSelectors,
  dotsMenu: invoicesOverviewDotsMenuSelectors,
  shareInvoiceDialog: shareInvoiceDialogSelectors,
  markPaidDialog: {
    ...markPaidDialogSelectors,
    ...dialogSelectors
  }
};

// src/screens/invoices/invoices-selectors/create-invoice-fixed-charges-tab-selectors.ts
var createInvoiceFixedChargesTabSelectors = {
  addFeesButton: "create-invoice-page-fixed-charges-tab-add-fees-button",
  oneTimeFeeOption: "create-invoice-page-fixed-charges-tab-one-menu-time-fee",
  creditOption: "create-invoice-page-fixed-charges-tab-credit-option"
};

// src/screens/invoices/invoices-selectors/create-invoice-settings-selectors.ts
var createInvoiceSettingsSelectors = {
  customerSelect: "create-invoice-page-settings-customer-select"
};

// src/screens/invoices/create-invoice-page-selectors.ts
var createInvoicePageSelectors = {
  settings: {
    ...createInvoiceSettingsSelectors
  },
  fixedChargesTab: {
    ...createInvoiceFixedChargesTabSelectors
  },
  continueButton: "create-invoice-page-continue-button"
};

// src/screens/invoices/invoices-selectors/dynamic-invoice-line-items.ts
var dynamicInvoiceContentSelectors = {
  fixedFeeLineItem: "dynamic-invoice-fixed-fee-line-item",
  usageLineItem: "dynamic-invoice-usage-line-item",
  perUnitField: "dynamic-invoice-per-unit-field",
  qtyField: "dynamic-invoice-qty-field",
  ytdQtyField: "dynamic-invoice-ytd-qty-field",
  bulkSizeField: "dynamic-invoice-bulk-size-field",
  billableQtyField: "dynamic-invoice-billable-qty-field",
  nonBillableQtyField: "dynamic-invoice-non-billable-qty-field",
  newPriceField: "dynamic-invoice-new-price-field",
  discountField: "dynamic-invoice-discount-field",
  amountField: "dynamic-invoice-amount-field",
  usageLineItemDetails: "dynamic-invoice-usage-line-item-details",
  fromField: "dynamic-invoice-from-field",
  toField: "dynamic-invoice-to-field",
  periodSelect: "dynamic-invoice-period-select",
  fixedRateField: "dynamic-invoice-fixed-rate-field"
};

// src/screens/invoices/invoices-selectors/dynamic-invoice-page-header-selectors.ts
var dynamicInvoicePageHeaderSelectors = {
  totalAmount: "dynamic-invoice-page-header-total-amount",
  billingCycle: "dynamic-invoice-page-header-billing-cycle",
  approveButton: "dynamic-invoice-page-header-approve-button",
  dotMenu: {
    menu: "dynamic-invoice-page-header-dot-menu",
    syncToStripe: "dynamic-invoice-page-header-dot-menu-sync-to-stripe"
  },
  pdfViewButton: "dynamic-invoice-page-header-pdf-view-button",
  exchangeRateDisplay: "dynamic-invoice-page-header-exchange-rate-display",
  exchangeRateCurrencySelect: "dynamic-invoice-page-header-exchange-rate-currency-select",
  exchangeRateInput: "dynamic-invoice-page-header-exchange-rate-input",
  exchangeRateResetButton: "dynamic-invoice-page-header-exchange-rate-reset-button"
};

// src/screens/invoices/invoices-selectors/dynamic-invoice-product-line-item-selectors.ts
var dynamicInvoiceProductLineItemSelectors = {
  lineItem: "dynamic-invoice-page-product-line-item",
  name: "dynamic-invoice-page-product-line-item-name",
  amount: "dynamic-invoice-page-product-line-item-amount",
  baseAmount: "dynamic-invoice-page-product-line-item-base-amount",
  quantity: "dynamic-invoice-page-product-line-item-quantity",
  commitment: "dynamic-invoice-page-product-line-item-commitment",
  percentage: "dynamic-invoice-page-product-line-item-percentage",
  period: "dynamic-invoice-page-product-line-item-period",
  commitmentUsage: "dynamic-invoice-page-product-line-item-commitment-usage",
  chips: {
    overage: "dynamic-invoice-page-product-line-item-chips-overage",
    autoUpgrade: "dynamic-invoice-page-product-line-item-chips-auto-upgrade",
    discount: "dynamic-invoice-page-product-line-item-chips-discount"
  }
};

// src/screens/invoices/invoices-selectors/dynamic-invoice-promotion-revison-modal-selectors.ts
var dynamicInvoicePromotionRevisionModalSelectors = {
  itemNameField: "dynamic-invoice-promotion-revision-modal-item-name-field",
  descriptionField: "dynamic-invoice-promotion-revision-modal-description-field",
  priceField: "dynamic-invoice-promotion-revision-modal-price-field",
  promotionTypeDropdownButton: "dynamic-invoice-promotion-revision-modal-promotion-type-dropdown-button",
  promotionTypeList: "dynamic-invoice-promotion-revision-modal-promotion-type-list"
};

// src/screens/invoices/invoices-selectors/dynamic-invoice-revision.ts
var dynamicInvoiceRevisionSelectors = {
  revisonAddItemButton: "dynamic-invoice-revision-add-item-button",
  revisionFixedFee: "dynamic-invoice-revision-fixed-fee",
  revisionFixedDiscount: "dynamic-invoice-revision-fixed-discount"
};

// src/screens/invoices/invoices-selectors/dynamic-invoice-revision-line-item-selectors.ts
var dynamicInvoiceRevisionLineItemSelectors = {
  revisionLineItem: "dynamic-invoice-revision-line-item",
  revisionTitile: "dynamic-invoice-revision-line-item-title",
  revisionDescription: "dynamic-invoice-revision-line-item-description",
  revisionPrice: "dynamic-invoice-revision-line-item-price",
  revisionBasePrice: "dynamic-invoice-revision-line-item-base-price",
  revisionOptions: "dynamic-invoice-revision-line-item-options",
  revisionPercentage: "dynamic-invoice-revision-line-item-percentage"
};

// src/screens/invoices/invoices-selectors/dynamic-invoice-revison-modal-selectors.ts
var dynamicInvoiceRevisionModalSelectors = {
  itemNameField: "dynamic-invoice-revision-modal-item-name-field",
  descriptionField: "dynamic-invoice-revision-modal-description-field",
  priceField: "dynamic-invoice-revision-modal-price-field"
};

// src/screens/invoices/invoices-selectors/dynamic-invoice-summary-selectors.ts
var dynamicInvoiceSummarySelectors = {
  totalAmount: "dynamic-invoice-page-summary-total-amount",
  discount: "dynamic-invoice-page-summary-discount"
};

// src/screens/invoices/invoices-selectors/sync-invoice-menu-selectors.ts
var syncInvoiceMenuSelectors = {
  syncInvoiceMenu: "sync-invoice-menu",
  syncToStripe: "sync-invoice-menu-sync-to-stripe",
  syncToNetSuite: "sync-invoice-menu-sync-to-netsuite",
  shareViaSlack: "sync-invoice-menu-share-via-slack",
  syncInvoiceSalesOrder: "sync-invoice-menu-sync-invoice-sales-order"
};

// src/screens/invoices/dynamic-invoice-page-selectors.ts
var dynamicInvoicePageSelectors = {
  header: {
    ...dynamicInvoicePageHeaderSelectors
  },
  syncInvoiceMenu: syncInvoiceMenuSelectors,
  productLineItem: {
    ...dynamicInvoiceProductLineItemSelectors
  },
  summary: {
    ...dynamicInvoiceSummarySelectors
  },
  content: {
    ...dynamicInvoiceContentSelectors
  },
  revision: {
    ...dynamicInvoiceRevisionLineItemSelectors,
    ...dynamicInvoiceRevisionSelectors,
    fixedRevisionModal: {
      ...dynamicInvoiceRevisionModalSelectors,
      ...dialogSelectors
    },
    promotionRevisionModal: {
      ...dynamicInvoicePromotionRevisionModalSelectors,
      ...dialogSelectors
    }
  }
};

// src/screens/invoices/invoices-selectors/light-invoice-page-selectors.ts
var lightInvoicePageSelectors = {
  pdfViewerCanvas: "light-invoice-page-pdf-viewer-canvas"
};

// src/screens/invoices/invoices-selectors/stripe-sync-status-selectors.ts
var stripeSyncStatusSelectors = {
  icon: "stripe-sync-status-stripe-icon"
};

// src/screens/invoices/netsuite-invoice-activity-selectors.ts
var netsuiteInvoiceActivitySelectors = {
  tab: "invoice-activity-netsuite-tab",
  integrationStatusAccordion: "invoice-activity-netsuite-integration-status-accordion",
  invoiceDetailsAccordion: "invoice-activity-netsuite-invoice-details-accordion",
  invoiceDashboardLink: "invoice-activity-netsuite-invoice-dashboard-link",
  syncStatusBadge: "invoice-activity-netsuite-sync-status-badge"
};

// src/screens/plans/plans-selectors/create-plan-tabs-selectors.ts
var createPlanTabsSelectors = {
  serviceFeesTab: "create-plan-tabs-service-fees-tab",
  tierAndVolumePricingTab: "create-plan-tabs-tier-and-volume-pricing-tab",
  promotionsTab: "create-plan-tabs-promotions-tab"
};

// src/screens/plans/plans-selectors/fixed-charge-edit-variants-list-item-selectors.ts
var fixedChargeEditVariantsListItemSelectors = {
  trashButton: "fixed-charge-edit-variants-list-item-trash-button"
};

// src/screens/plans/plans-selectors/fixed-charges-menu-items-selectors.ts
var fixedChargesMenuItemsSelectors = {
  oneTimeFee: "fixed-charges-menu-items-one-time-fee",
  subscriptionFee: "fixed-charges-menu-items-subscription-fee",
  creditFee: "fixed-charges-menu-items-credit-fee"
};

// src/screens/plans/plans-selectors/fixed-charges-header-edit-selectors.ts
var fixedChargesHeaderEditSelectors = {
  nameInput: "fixed-charges-header-edit-name-input",
  descriptionInput: "fixed-charges-header-edit-description-input",
  amountInput: "fixed-charges-header-edit-amount-input"
};

// src/screens/plans/plans-selectors/fixed-charges-tab-content-selectors.ts
var fixedChargesTabContentSelectors = {
  addFeeButton: "fixed-charges-tab-content-add-fee-button"
};

// src/screens/plans/plans-selectors/fixed-charges-edit-columns-selectors.ts
var fixedChargesEditColumnsSelectors = {
  nameInput: "fixed-charges-edit-columns-name-input",
  amountInput: "fixed-charges-edit-columns-amount-input",
  removeRowButton: "fixed-charges-edit-columns-remove-row-button"
};

// src/screens/plans/plans-selectors/create-plan-page-header-selectors.ts
var createPlanPageHeaderSelectors = {
  planNameInput: "create-plan-page-header-plan-name-input"
};

// src/screens/plans/plans-selectors/create-plan-drawer-selectors.ts
var createPlanDrawerSelectors = {
  modifyButton: "create-plan-drawer-modify-button",
  closeButton: "create-plan-drawer-close-button",
  settingOptions: "create-plan-drawer-setting-options",
  commitmentSettings: {
    amount: "create-plan-drawer-commitment-settings-input"
  }
};

// src/screens/plans/plans-selectors/create-plan-components-selectors/create-plan-stepper-navigatior-selectors.ts
var createPlanPageStepperNavigatorSelectors = {
  submitFormButton: "plan-submit-form-btn"
};

// src/screens/plans/plans-selectors/create-plan-components-selectors/save-and-assign-contract-selectors.ts
var saveAndAssignContractSelectors = {
  saveAndAssignContractButton: "save-and-assign-contract-btn"
};

// src/screens/plans/plans-selectors/create-plan-components-selectors/usage-charges-tab-content-selectors.ts
var usageChargesTabContentSelectors = {
  addFeeButton: "usage-charges-tab-content-add-fee-button",
  meterMenuItem: "usage-charges-tab-content-meter-menu-item"
};

// src/screens/plans/plans-selectors/create-plan-components-selectors/create-plan-usage-charges-selectors/index.ts
var createPlanUsageChargesSelectors = {
  clearTierValueButton: "clear-tier-value-button"
};

// src/screens/plans/plans-selectors/create-plan-details-selectors.ts
var createPlanDetailsSelectors = {
  nameInput: "create-plan-details-name-input",
  descriptionInput: "create-plan-details-description-input"
};

// src/screens/plans/plans-selectors/usage-charge-selectors/per-unit-usage-charge-form-selectors.ts
var perUnitUsageChargeFormSelectors = {
  nameInput: "per-unit-usage-charge-form-name-input",
  priceInput: "per-unit-usage-charge-form-price-input",
  drawer: {
    meterResetDrowpdownButton: "per-unit-usage-charge-form-meter-reset-dropdown-button"
  }
};

// src/screens/plans/plans-selectors/usage-charge-selectors/per-unit-usage-charge-edit-bottom-section-selectors.ts
var perUnitUsageChargeEditBottomSectionSelectors = {
  trashButton: "per-unit-usage-charge-edit-bottom-section-trash-button"
};

// src/screens/plans/plans-selectors/usage-charge-selectors/usage-product-variant-header-edit-selectors.ts
var usageProductVariantHeaderEditSelectors = {
  nameInput: "usage-product-variant-header-edit-name-input",
  descriptionInput: "usage-product-variant-header-edit-description-input"
};

// src/screens/plans/plans-selectors/usage-charge-selectors/usage-product-variant-summary-selectors.ts
var usageProductVariantSummarySelectors = {
  commitmentAmountInput: "usage-product-variant-summary-commitment-amount-input",
  trashButton: "usage-product-variant-summary-trash-button"
};

// src/screens/shared/product-source-select-selectors.ts
var productSourceSelectSelectors = {
  selectInput: "product-source-select-select-input",
  selectInputItem: "product-source-select-select-input-item"
};

// src/screens/shared/add-item-button-selectors.ts
var addItemButtonSelectors = {
  button: "add-item-button-button",
  menuItems: {
    fixedFeeItem: "add-item-button-menu-item-fixed-fee",
    subscriptionFeeItem: "add-item-button-menu-item-subscription-fee",
    tieredPricingItem: "add-item-button-menu-item-tiered-pricing",
    perUnitPricingItem: "add-item-button-menu-item-per-unit-pricing",
    volumeBasedTiersItem: "add-item-button-menu-item-volume-based-tiers",
    promotionsItem: "add-item-button-menu-item-promotions",
    commissionItem: "add-item-button-menu-item-commission",
    fixedPerUnitItem: "add-item-button-menu-item-fixed-per-unit",
    installmentsItem: "add-item-button-menu-item-installments",
    commercialTermsItem: "add-item-button-menu-item-commercial-terms"
  }
};

// src/screens/plans/create-plan-page-selectors.ts
var createPlanPageSelectors = {
  details: createPlanDetailsSelectors,
  addItemButton: addItemButtonSelectors,
  tabs: {
    buttons: createPlanTabsSelectors,
    sections: {
      fixedCharges: {
        ...fixedChargesTabContentSelectors,
        ...fixedChargesMenuItemsSelectors
      },
      usageCharges: {
        ...usageChargesTabContentSelectors
      }
    }
  },
  products: {
    fixed: {
      headerEdit: fixedChargesHeaderEditSelectors,
      ...fixedChargeEditVariantsListItemSelectors,
      ...fixedChargesEditColumnsSelectors
    },
    usage: {
      ...createPlanUsageChargesSelectors,
      perUnit: {
        ...perUnitUsageChargeFormSelectors,
        meter: productSourceSelectSelectors,
        ...perUnitUsageChargeEditBottomSectionSelectors
      },
      tiers: {
        ...usageProductVariantHeaderEditSelectors,
        meter: productSourceSelectSelectors,
        ...usageProductVariantSummarySelectors
      }
    }
  },
  drawer: {
    ...createPlanDrawerSelectors
  },
  header: {
    ...createPlanPageHeaderSelectors
  },
  stepper: {
    ...createPlanPageStepperNavigatorSelectors
  },
  saveAndAssignContract: {
    ...saveAndAssignContractSelectors
  }
};

// src/screens/plans/plans-overview-page-selectors.ts
var planCreationOptionsDialogSelectors = {
  dialog: "plan-creation-options-dialog",
  optionCardNewContract: "plan-creation-options-dialog-option-new-contract",
  optionCardNewTemplate: "plan-creation-options-dialog-option-new-template",
  optionCardChooseTemplate: "plan-creation-options-dialog-option-choose-template",
  cancelButton: "plan-creation-options-dialog-cancel-button",
  nextButton: "plan-creation-options-dialog-next-button"
};
var selectPlanTemplateDialogSelectors = {
  dialog: "select-plan-template-dialog-root",
  searchInput: "select-plan-template-dialog-search-input",
  cancelButton: "select-plan-template-dialog-cancel-button",
  nextButton: "select-plan-template-dialog-next-button",
  tableRow: "select-plan-template-dialog-table-row"
};
var plansOverviewPageSelectors = {
  table: "plans-overview-table",
  createPlanButton: "plans-overview-create-plan-button",
  templatesTab: "plans-overview-templates-tab",
  contractsTab: "plans-overview-contracts-tab",
  duplicateButton: "plans-overview-duplicate-button",
  dotsMenu: "plans-overview-dots-menu"
};
var duplicateOptionsDialogSelectors = {
  saveAsTemplateOption: "duplicate-options-dialog-save-as-template-option",
  startNewContractOption: "duplicate-options-dialog-start-new-contract-option"
};
var plansGettingStartedSelectors = {
  templateCard: "plans-getting-started-template-card",
  actionCard: "plans-getting-started-action-card",
  newContractButton: "plans-getting-started-new-contract-button",
  newPlanButton: "plans-getting-started-new-plan-button",
  templateUseButton: "plans-getting-started-template-use-button",
  viewAllButton: "plans-getting-started-view-all-button",
  backButton: "plans-getting-started-back-button",
  pageTitle: "plans-getting-started-page-title"
};

// src/screens/contracts/contracts-selectors/contract-usage-page-table-selectors.ts
var contractUsagePageTableSelectors = {
  productName: "contract-usage-page-table-product-name",
  pricingType: "contract-usage-page-table-pricing-type",
  pricePerUnit: "contract-usage-page-table-price-per-unit",
  billingInterval: "contract-usage-page-table-billing-interval",
  commitment: "contract-usage-page-table-commitment",
  meterReset: "contract-usage-page-table-meter-reset",
  meterRefill: "contract-usage-page-table-meter-refill"
};

// src/screens/contracts/contracts-selectors/contract-page-selectors/contract-page-header-selectors.ts
var contractPageHeaderSelectors = {
  contractMenuButton: "contract-menu-btn",
  editPlanNameButton: "edit-plan-name-btn",
  cloneContractMenuItem: "contract-clone-menu-item"
};

// src/screens/contracts/contract-page-selectors.ts
var contractPageSelectors = {
  header: {
    ...contractPageHeaderSelectors
  },
  usageTable: {
    ...contractUsagePageTableSelectors
  }
};

// src/screens/contracts/contracts-selectors/revise-contract-for-renewal-dialog-form-selectors.ts
var reviseContractForRenewalDialogFormSelectors = {
  dialog: "revise-contract-for-renewal-dialog-form-dialog"
};

// src/screens/contracts/contracts-selectors/revise-current-contract-dialog-form-selectors.ts
var reviseCurrentContractDialogFormSelectors = {
  dialog: "revise-current-contract-dialog-form-dialog"
};

// src/screens/contracts/contract-revision-page-selectors.ts
var contractRevisionPageSelectors = {
  reviseCurrentContract: {
    saveButton: "contract-revise-page-current-contract-save-button",
    dialogForm: reviseCurrentContractDialogFormSelectors
  },
  reviseContractForRenewal: {
    saveButton: "contract-revise-page-contract-for-renewal-save-button",
    dialogForm: reviseContractForRenewalDialogFormSelectors
  }
};

// src/screens/contracts/contracts-selectors/contracts-table-selectors/contracts-table-toolbar-selectors.ts
var contractsTableToolbarSelectors = {
  createContractButton: "contracts-table-create-contract-btn"
};

// src/screens/contracts/contracts-overview-page-selectors.ts
var contractsOverviewPageSelectors = {
  toolbar: {
    ...contractsTableToolbarSelectors
  }
};

// src/screens/contracts/contracts-selectors/update-contract-page-selectors.ts
var updateContractSelectors = {
  dialog: {
    ...dialogSelectors
  }
};

// src/screens/contracts/netsuite-sync-wizard-selectors.ts
var netsuiteSyncWizardSelectors = {
  openMenuItem: "contract-menu-netsuite-export",
  customerStep: "netsuite-sync-wizard-customer-step",
  customerInput: "netsuite-sync-wizard-customer-input",
  productStep: "netsuite-sync-wizard-product-step",
  subsidiaryStep: "netsuite-sync-wizard-subsidiary-step",
  subsidiarySelect: "netsuite-sync-wizard-subsidiary-select"
};

// src/screens/usage/usage-selectors/usage-page-table-selectors.ts
var usagePageTableSelectors = {
  checkbox: "usage-page-table-checkbox",
  day: "usage-page-table-day",
  customerId: "usage-page-table-customer-id",
  customer: "usage-page-table-customer",
  product: "usage-page-table-product",
  subProduct: "usage-page-table-sub-product",
  quantity: "usage-page-table-quantity",
  price: "usage-page-table-price",
  dotsMenu: {
    dotsMenuButton: "usage-page-table-dot-menu-button",
    editButton: "usage-page-table-dot-menu-edit-button",
    deleteButton: "usage-page-table-dot-menu-delete-button"
  }
};

// src/screens/usage/usage-selectors/usage-page-header-selectors.ts
var usagePageHeaderSelectors = {
  rangeSelectButton: "usage-page-header-range-picker-button",
  customerDropdownButton: "usage-page-header-customer-dorpdown-button",
  productDropdownButton: "usage-page-header-product-dropdown-button",
  downloadCsvButton: "usage-page-header-download-csv-button",
  dotMenu: {
    dotMenuButton: "usage-page-header-dot-menu-button",
    uploadDataButton: "usage-page-header-dot-menu-upload-data-button"
  }
};

// src/screens/usage/usage-selectors/usage-upload-dialog.ts
var usageUploadDialogSelectors = {
  uploadFileContainer: "usage-upload-dialog-upload-file-container",
  successIcon: "usage-upload-dialog-success-icon",
  fileName: "usage-upload-dialog-file-name"
};

// src/screens/usage/usage-page-selectors.ts
var usagePageSelectors = {
  header: {
    ...usagePageHeaderSelectors
  },
  usageUploadDialog: {
    ...usageUploadDialogSelectors
  },
  measurementsTable: {
    ...usagePageTableSelectors
  }
};

// src/screens/customers/create-customer-page-selectors.ts
var createCustomerPageSelectors = {
  companyDetails: {
    name: "create-customer-page-company-details-name",
    legalName: "create-customer-page-company-details-legal-name",
    taxIds: "create-customer-page-company-details-tax-ids",
    country: "create-customer-page-company-details-country",
    state: "create-customer-page-company-details-state",
    city: "create-customer-page-company-details-city",
    address: "create-customer-page-company-details-address",
    postalCode: "create-customer-page-company-details-postal-code",
    addContact: "create-customer-page-company-details-contacts-add-contact",
    contactName: "create-customer-page-company-details-contacts-contact-name",
    contactEmail: "create-customer-page-company-details-contacts-contact-email",
    contactPhone: "create-customer-page-company-details-contacts-contact-phone",
    contactTitle: "create-customer-page-company-details-contacts-contact-title"
  },
  configuration: {
    externalId: "create-customer-page-configuration-external-id",
    crmId: "create-customer-page-configuration-crm-id",
    erpId: "create-customer-page-configuration-erp-id",
    overage: "create-customer-page-configuration-overage",
    customerType: "create-customer-page-configuration-customer-type",
    currency: "create-customer-page-configuration-currency",
    tax: "create-customer-page-configuration-tax",
    invoiceDueDate: "create-customer-page-configuration-invoice-due-date",
    manualReview: "create-customer-page-configuration-manual-review",
    primaryPaymentProvider: "create-customer-page-configuration-primary-payment-provider",
    secondaryPaymentProvider: "create-customer-page-configuration-secondary-payment-provider",
    wallet: "create-customer-page-configuration-wallet",
    autoCollectInvoice: "create-customer-page-configuration-auto-collect-invoice"
  },
  advanced: {
    addAlias: "create-customer-page-advanced-add-alias",
    alias: "create-customer-page-advanced-alias"
  },
  saveForm: "create-customer-page-save-form"
};

// src/screens/customers/customers-overview-page-selectors.ts
var customersOverviewColumnSelectors = {
  status: "customers-overview-status",
  name: "customers-overview-name",
  labels: "customers-overview-labels",
  legalName: "customers-overview-legal-name",
  crmId: "customers-overview-crm-id",
  erpId: "customers-overview-erp-id",
  taxId: "customers-overview-tax-id",
  taxType: "customers-overview-tax-type",
  wallet: "customers-overview-wallet",
  aliases: "customers-overview-aliases",
  contractsCount: "customers-overview-contracts-count",
  subsidiary: "customers-overview-subsidiary",
  createdAt: "customers-overview-created-at",
  address: "customers-overview-address",
  country: "customers-overview-country",
  state: "customers-overview-state",
  city: "customers-overview-city",
  postalCode: "customers-overview-postal-code",
  paymentDueDays: "customers-overview-payment-due-days",
  manualReview: "customers-overview-manual-review",
  parentCustomer: "customers-overview-parent-customer"
};
var customersOverviewPageSelectors = {
  table: "customers-overview-table",
  createCustomerButton: "customers-overview-create-customer-button",
  columns: customersOverviewColumnSelectors
};

// src/screens/customers/customer-detail-page-selectors.ts
var customerDetailPageSelectors = {
  invoicesTab: "customer-detail-invoices-tab",
  invoicesTable: "customer-detail-invoices-table",
  actionsButton: "customer-detail-actions-button",
  actionsMenu: "customer-detail-actions-menu"
};

// src/screens/customers/stripe-customer-dropdown-selectors.ts
var stripeCustomerDropdownSelectors = {
  root: "stripe-customer-dropdown"
};

// src/screens/customers/netsuite-customer-dropdown-selectors.ts
var netsuiteCustomerDropdownSelectors = {
  root: "netsuite-customer-dropdown"
};

// src/screens/customers/netsuite-credit-note-menu-selectors.ts
var netsuiteCreditNoteMenuSelectors = {
  syncMenuTrigger: "credit-note-dot-menu-sync",
  syncToNetSuite: "credit-note-sync-to-netsuite"
};

// src/screens/shared/create-contract-form-selectors.ts
var createContractFormSelectors = {
  customerSelect: "create-contract-form-customer-select",
  startDateInput: "create-contract-form-start-date-input"
};

// src/screens/shared/vy-table-selectors.ts
var vyTableSelectors = {
  root: "vy-table-root",
  row: "vy-table-row",
  columnSettings: "vy-table-column-settings",
  searchInput: "vy-table-search-input",
  filterButton: "vy-table-filter-button",
  filterPopover: "vy-table-filter-popover",
  checkbox: "vy-table-checkbox",
  dateRangePicker: "vy-table-date-range-picker",
  filterFieldSelect: "vy-table-filter-field-select",
  filterOperatorSelect: "vy-table-filter-operator-select",
  filterValueSelect: "vy-table-filter-value-select",
  pagination: "vy-table-pagination",
  columnSettingsPopover: "vy-table-column-settings-popover",
  filterBadge: "vy-table-filter-badge"
};

// src/screens/shared/commercial-terms-selectors.ts
var commercialTermsSelectors = {
  disclosureButton: "commercial-terms-disclosure-button",
  commitmentDescriptionInput: "commercial-terms-commitment-description-input",
  commitmentAmountInput: "commercial-terms-commitment-amount-input",
  paymentTermSelect: "commercial-terms-payment-term-select",
  paymentTermSelectItem: "commercial-terms-payment-term-select-item"
};

// src/screens/shared/integration-provider-tabs-selectors.ts
var integrationProviderTabsSelectors = {
  entityMappingTab: "integration-provider-tabs-entity-mapping-tab",
  configurationTab: "integration-provider-tabs-configuration-tab"
};

// src/screens/shared/header-selectors.ts
var headerSelectors = {
  notifications: {
    notificationButton: "header-notification-button",
    notificationCard: "header-notification-card",
    notificationCardContent: {
      cardTitle: "header-notification-card-title",
      cardMetaData: "header-notification-card-meta-data",
      cardIcon: {
        loading: "header-notification-card-icon-loading",
        success: "header-notification-card-icon-success",
        failed: "header-notification-card-icon-failed"
      },
      dismissButton: "header-notification-card-dismiss-button",
      reviewNotificationButton: "header-notification-card-review-notification-button"
    }
  },
  accountSettings: {
    accountDropdownButton: "header-account-dropdown-button",
    helpCenterButton: "header-help-center-button",
    settingsButton: "header-settings-button",
    logoutButton: "header-logout-button"
  }
};

// src/screens/shared/navigation-selectors.ts
var navigationSelectors = {
  sidebar: "navigation-sidebar",
  customersLink: "navigation-customers-link",
  invoicesLink: "navigation-invoices-link",
  invoicesOverviewLink: "navigation-invoices-overview-link",
  invoicesPaymentsLink: "navigation-invoices-payments-link",
  plansLink: "navigation-plans-link",
  usageLink: "navigation-usage-link",
  dataMeteringUsageLink: "navigation-data-metering-usage-link",
  dataMeteringEventsLink: "navigation-data-metering-events-link",
  reportsLink: "navigation-reports-link",
  productsLink: "navigation-products-link",
  integrationsLink: "navigation-integrations-link",
  homeLink: "navigation-home-link"
};

// src/screens/payments/payments-page-selectors.ts
var paymentsOverviewColumnSelectors = {
  customerName: "payments-page-customer-name",
  amount: "payments-page-amount",
  invoiceNumber: "payments-page-invoice-number",
  currency: "payments-page-currency",
  status: "payments-page-status",
  transactionDate: "payments-page-transaction-date",
  provider: "payments-page-provider"
};
var paymentsPageSelectors = {
  table: "payments-page-table",
  searchInput: "payments-page-search-input",
  columns: paymentsOverviewColumnSelectors
};

// src/screens/integrations/integrations-page-selectors.ts
var integrationsPageSelectors = {
  card: {
    root: "integration-card",
    connectButton: "integration-card-connect-button",
    manageButton: "integration-card-manage-button",
    badge: "integration-card-badge"
  },
  drawer: {
    closeButton: "integration-drawer-close-button",
    stripe: {
      apiTokenInput: "stripe-api-token-input",
      registration: {
        connectButton: "stripe-registration-connect-button"
      },
      configuration: {
        modifyKeyButton: "stripe-configuration-modify-key-button",
        saveButton: "stripe-configuration-save-button"
      }
    }
  }
};

// src/screens/integrations/netsuite-integration-selectors.ts
var netsuiteIntegrationSelectors = {
  registration: {
    form: "netsuite-registration-form",
    accountRealmInput: "netsuite-registration-account-realm-input",
    certificateIdInput: "netsuite-registration-certificate-id-input",
    clientIdInput: "netsuite-registration-client-id-input",
    connectButton: "netsuite-registration-connect-button"
  },
  configuration: {
    saveButton: "netsuite-configuration-save-button",
    disconnectButton: "netsuite-configuration-disconnect-button",
    autoExportInvoicesToggle: "netsuite-configuration-auto-export-invoices-toggle",
    autoExportCustomersToggle: "netsuite-configuration-auto-export-customers-toggle",
    autoExportCreditMemosToggle: "netsuite-configuration-auto-export-credit-memos-toggle",
    summarizeLineItemsToggle: "netsuite-configuration-summarize-line-items-toggle",
    overrideQuantityToggle: "netsuite-configuration-override-quantity-toggle",
    taxStrategyRadio: "netsuite-configuration-tax-strategy-radio",
    invoiceNumberStrategyRadio: "netsuite-configuration-invoice-number-strategy-radio",
    invoicePaymentStatusStrategyRadio: "netsuite-configuration-invoice-payment-status-strategy-radio",
    accountTaxItemPicker: "netsuite-configuration-account-tax-item-picker",
    defaultReceivableAccountPicker: "netsuite-configuration-default-receivable-account-picker",
    defaultProductPicker: "netsuite-configuration-default-product-picker",
    depositToAccountPicker: "netsuite-configuration-deposit-to-account-picker"
  }
};

// src/utils/cy-data.ts
function vyData(selectorAttribute) {
  return `[data-vy="${selectorAttribute}"]`;
}

// src/utils/get-selector-attribute.ts
function getSelectorAttribute(selector) {
  return {
    ["data-vy"]: selector
  };
}
export {
  addItemButtonSelectors,
  commercialTermsSelectors,
  contractPageSelectors,
  contractRevisionPageSelectors,
  contractsOverviewPageSelectors,
  createContractFormSelectors,
  createCustomerPageSelectors,
  createInvoiceFixedChargesTabSelectors,
  createInvoicePageSelectors,
  createInvoiceSettingsSelectors,
  createPlanPageSelectors,
  customerDetailPageSelectors,
  customersOverviewColumnSelectors,
  customersOverviewPageSelectors,
  dialogSelectors,
  duplicateOptionsDialogSelectors,
  dynamicInvoiceContentSelectors,
  dynamicInvoicePageHeaderSelectors,
  dynamicInvoicePageSelectors,
  dynamicInvoiceProductLineItemSelectors,
  dynamicInvoicePromotionRevisionModalSelectors,
  dynamicInvoiceRevisionLineItemSelectors,
  dynamicInvoiceRevisionModalSelectors,
  dynamicInvoiceRevisionSelectors,
  dynamicInvoiceSummarySelectors,
  getSelectorAttribute,
  headerSelectors,
  homePageSelectors,
  homePageWidgetsSelectors,
  integrationProviderTabsSelectors,
  integrationsPageSelectors,
  invoicesOverviewActionButtonSelector,
  invoicesOverviewColumnSelectors,
  invoicesOverviewDotsMenuSelectors,
  invoicesOverviewHighlightsSelectors,
  invoicesOverviewPageSelectors,
  lightInvoicePageSelectors,
  loginPageSelectors,
  markPaidDialogSelectors,
  navigationSelectors,
  netsuiteCreditNoteMenuSelectors,
  netsuiteCustomerDropdownSelectors,
  netsuiteIntegrationSelectors,
  netsuiteInvoiceActivitySelectors,
  netsuiteSyncWizardSelectors,
  paymentsOverviewColumnSelectors,
  paymentsPageSelectors,
  planCreationOptionsDialogSelectors,
  plansGettingStartedSelectors,
  plansOverviewPageSelectors,
  productSourceSelectSelectors,
  selectPlanTemplateDialogSelectors,
  shareInvoiceDialogSelectors,
  stripeCustomerDropdownSelectors,
  stripeSyncStatusSelectors,
  syncInvoiceMenuSelectors,
  updateContractSelectors,
  usagePageSelectors,
  vyData,
  vyTableSelectors
};
